import { render, staticRenderFns } from "./TabsContent2.vue?vue&type=template&id=7ee8bd0c&scoped=true"
import script from "./TabsContent2.vue?vue&type=script&lang=js"
export * from "./TabsContent2.vue?vue&type=script&lang=js"
import style0 from "./TabsContent2.vue?vue&type=style&index=0&id=7ee8bd0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee8bd0c",
  null
  
)

export default component.exports